import React from 'react';
import { Link } from 'react-router-dom';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => (
  <div className="privacy-policy-page">
    <div className="privacy-policy-inner">
      <h1>Privacy Policy</h1>
      <p className="privacy-policy-lead">
        This page is a placeholder. Replace this content with your final policy and keep the URL
        at <code>/privacy</code> so in-app links stay valid.
      </p>
      <p>
        We collect and use account and usage data only as needed to run the service. For questions,
        contact the email shown in your app or marketing site.
      </p>
      <p>
        <Link to="/">Back to home</Link>
      </p>
    </div>
  </div>
);

export default PrivacyPolicy;
